<template>
    <div class="usuario animate__animated animate__fadeIn animate__fast">
        <div class="card">
            <div class="card-header">
                <h5 class="card-title title-primary">
                    <img src="@/assets/img/usuario.png" width="40" height="40"/> Información de usuario
                </h5>
            </div>

            <div v-if="!usuario" class="card-body">
                <h4 class="title mt-0 text-center text-danger">No se ha encontrado informacion del usuario</h4>
            </div>

            <div v-else class="card-body">
                <h3 class="title mt-0 text-center">Informacion del estudiante</h3>

                <p class="small text-center text-primary bolder">A continuación, se mustra la información del estudiante, donde usted puede actualizar solamente el correo del estudiante</p>

                <div class="form-row">
                    <div class="form-group">
                        <label>Nombres: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Nombres del estudiante"
                                readonly 
                                disabled
                                v-model="usuario.nombres"
                        >
                    </div>

                    <div class="form-group">
                        <label>Apellidos: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Apellidos del estudiante"
                                readonly 
                                disabled
                                v-model="usuario.apellidos"
                        >
                    </div>

                    <div class="form-group">
                        <label>Tipo de identificación: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Tipo de identificación"
                                readonly 
                                disabled
                                v-model="usuario.tipo_documento"
                        >
                    </div>

                    <div class="form-group">
                        <label>Identificación: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Número de identificación"
                                readonly 
                                disabled
                                v-model="usuario.documento"
                        >
                    </div>

                    <div class="form-group">
                        <label>Código: </label>
                        <input type="text"
                                class="form-control bold"
                                placeholder="Código estudiantil"
                                readonly 
                                disabled
                                v-model="usuario.codigo"
                        >
                    </div>

                    <div class="form-group">
                        <label>Correo: </label>
                        <input type="text"
                                class="form-control text-primary bolder" 
                                id="inputCorreo" 
                                placeholder="Correo"
                                v-model="new_correo"
                        >
                    </div>

                    <div class="form-group">
                        <label>Celular: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Celular"
                                readonly 
                                disabled
                                v-model="usuario.celular"
                        >
                    </div>

                    <div class="form-group">
                        <label>Programa: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Programa"
                                readonly 
                                disabled
                                v-model="usuario.programa"
                        >
                    </div>

                    <div class="form-group">
                        <label>Semestre: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Semestre"
                                readonly 
                                disabled
                                v-model="usuario.semestre"
                        >
                    </div>

                    <div class="form-group">
                        <label>Sede: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Sede"
                                readonly 
                                disabled
                                v-model="usuario.sede.nombre_sede"
                        >
                    </div>

                    <div class="form-group">
                        <label>Tipo de apoyo: </label>
                        <input type="text"
                                class="form-control bold" 
                                placeholder="Sede"
                                readonly 
                                disabled
                                v-model="usuario.tipo_apoyo.nombre_apoyo"
                        >
                    </div>
                </div>

                <hr>
                <h3 class="title mt-0 text-center">Informacion bancaria</h3>
                
                <p v-if="!usuario.info_bancaria" class="text-danger text-center bolder">El estudiante aun no registra su información bancaria</p>

                <div v-else class="form-row">
                    <div class="form-group">
                        <label>Entidad bancaria: </label>
                        <input type="text"
                               class="form-control bold"
                               placeholder="Entidad bancaria"
                               readonly
                               disabled
                               v-model="usuario.info_bancaria.entidad_bancaria.nombre_banco"
                        >
                    </div>

                    <div class="form-group">
                        <label>Tipo de cuenta: </label>
                        <input type="text"
                               class="form-control bold"
                               placeholder="Tipo de cuenta"
                               readonly
                               disabled
                               v-model="usuario.info_bancaria.tipo_cuenta.tipo_cuenta"
                        >
                    </div>

                    <div class="form-group">
                        <label>Número de cuenta: </label>
                        <input type="text"
                               class="form-control bold"
                               placeholder="Número de cuenta"
                               readonly
                               disabled
                               v-model="usuario.info_bancaria.numero_cuenta"
                        >
                    </div>
                </div>

                <div v-if="usuario.info_bancaria.certificado" class="d-flex">
                    <a :href="api_url+'pdf/'+usuario.info_bancaria.certificado" target="_blank" class="btn btn-small btn-primary bolder d-flex mb-0 mt-0" style="font-size: 0.9rem;">
                        <img src="@/assets/img/pdf.svg" width="20" height="20" style="margin-right: 3px;" />
                        Ver certificado
                    </a>
                </div>

                
            </div>

            <div v-if="usuario" class="card-footer">
                <button type="button" @click.prevent="actualizarCorreoUsuario" :disabled="!new_correo" class="btn btn-primary">Actualizar correo</button>
            </div>
            
        </div>
    </div>
</template>

<script>
import { getInfoUsuario, updateCorreoUsuario } from '../api/admin.api';
export default {
    name: 'Usuario',
    data() {
        return {
            usuario: null,
            new_correo: null,
            documento: this.$route.params.documento,
            api_url: process.env.VUE_APP_API_URI
        }
    },
    created() {
        this.infoUsuario();
    },
    methods: {
        async infoUsuario() {
            this.$store.dispatch('startLoading');
            try {
                const { data } = await getInfoUsuario(this.documento);
                this.$store.dispatch('finishLoading');

                if(data.error) {
                    this.$store.dispatch('showError', data.error);
                    return;
                }

                this.usuario = data.usuario;
                this.new_correo = data.usuario.correo;

                setTimeout(() => {
                    document.getElementById('inputCorreo').focus()
                }, 100)

            } catch (error) {
                console.error(error);
                this.$store.dispatch('showError');
            }
        },
        async actualizarCorreoUsuario() {

            this.$store.dispatch('startLoading');
            try {
                const { data } = await updateCorreoUsuario(this.documento, { correo: this.new_correo });
                this.$store.dispatch('finishLoading');

                if(data.error) {
                    this.$store.dispatch('showError', data.error);
                    return;
                }

                this.$store.dispatch('showSuccess', data.message);

            } catch (error) {
                console.error(error);
                this.$store.dispatch('showError');
            }
        }
    },
}
</script>

<style scoped>
.usuario .card {
    width: 95%;
    max-width: 1000px;
    box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, .2);
}

.usuario #inputCorreo {
    border-width: 2px;
}

.usuario .form-row {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
}

.usuario .form-row .form-group {
    width: 32.5%;
}

@media only screen and (max-width: 680px) {
    .usuario .form-row .form-group {
        width: 49.5%;
    }
}

@media only screen and (max-width: 480px) {
    .usuario .form-row .form-group {
        width: 100%;
    }
}
</style>